import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getSupabase } from '@litopia/shared/supabase';
import { useSharedAuth } from '@litopia/shared';
import { logError } from '../../utils/errorHandler';

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user } = useSharedAuth();
  const [status, setStatus] = useState<'loading' | 'allowed' | 'denied'>('loading');

  useEffect(() => {
    if (!user) {
      setStatus('denied');
      return;
    }
    const sb = getSupabase();

    // The shared store already verified this document's identity, so the guard doesn't
    // check it twice; is_opp_admin() is the authority and fails on a revoked token.
    void (async () => {
      try {
        const { data, error } = await sb.rpc('is_opp_admin');
        if (error) {
          logError(error.message, 'AdminGuard is_opp_admin RPC');
          setStatus('denied');
          return;
        }
        setStatus(data === true ? 'allowed' : 'denied');
      } catch {
        setStatus('denied');
      }
    })();
  }, [user]);

  if (status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="w-6 h-6 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  if (status === 'denied') return <Navigate to="/login" replace />;

  return <>{children}</>;
}
